var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.181 89.999 c -0.763 0 -1.529 -0.182 -2.234 -0.55 c -1.597 -0.835 -2.588 -2.472 -2.588 -4.274 V 7.504 C 10.358 3.366 13.725 0 17.862 0 h 54.276 c 4.137 0 7.503 3.366 7.503 7.504 v 77.672 c 0 1.801 -0.991 3.439 -2.588 4.273 c -1.598 0.836 -3.506 0.714 -4.985 -0.313 v -0.001 L 47.684 72.177 c -1.606 -1.115 -3.763 -1.115 -5.367 0 L 17.932 89.134 C 17.107 89.708 16.146 89.999 15.181 89.999 z M 74.352 85.851 c 0.354 0.244 0.684 0.14 0.85 0.053 c 0.164 -0.086 0.44 -0.295 0.44 -0.728 V 7.504 C 75.642 5.572 74.07 4 72.139 4 H 17.862 c -1.932 0 -3.504 1.572 -3.504 3.504 v 77.672 c 0 0.433 0.276 0.642 0.441 0.728 c 0.166 0.088 0.494 0.193 0.849 -0.053 l 24.384 -16.957 c 2.972 -2.067 6.966 -2.067 9.935 0 L 74.352 85.851 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(232,37,42)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34.439 54.502 c -0.762 0 -1.519 -0.238 -2.166 -0.708 c -1.145 -0.832 -1.708 -2.215 -1.469 -3.61 l 1.689 -9.843 l -7.152 -6.971 c -1.013 -0.987 -1.372 -2.437 -0.935 -3.783 c 0.438 -1.347 1.579 -2.309 2.98 -2.513 l 9.883 -1.436 l 4.42 -8.956 c 0.627 -1.269 1.895 -2.057 3.31 -2.057 s 2.684 0.788 3.31 2.057 c 0 0 0 0 0.001 0 l 4.419 8.956 l 9.883 1.437 c 1.401 0.204 2.543 1.167 2.981 2.513 c 0.438 1.346 0.079 2.795 -0.935 3.783 l -7.151 6.971 l 1.688 9.843 c 0.239 1.395 -0.323 2.777 -1.469 3.609 c -1.145 0.832 -2.636 0.938 -3.887 0.281 L 45 49.427 l -8.84 4.648 C 35.615 54.361 35.026 54.502 34.439 54.502 z M 28.582 30.942 l 6.82 6.648 c 0.871 0.849 1.267 2.07 1.062 3.268 l -1.61 9.385 l 8.429 -4.432 c 1.076 -0.564 2.36 -0.564 3.435 0 l 8.43 4.432 l -1.609 -9.386 c -0.206 -1.196 0.19 -2.419 1.064 -3.268 l 6.818 -6.646 l -9.425 -1.37 c -1.201 -0.174 -2.239 -0.929 -2.778 -2.018 L 45 19.013 l -4.215 8.54 c -0.537 1.089 -1.576 1.844 -2.779 2.019 L 28.582 30.942 z M 52.802 25.782 h 0.01 H 52.802 z M 44.723 18.452 c 0 0 0 0.001 0.001 0.001 L 44.723 18.452 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(232,37,42)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.1a196b9e7bb698b8822111526536b194.svg";
export { ForwardRef as ReactComponent };